<template>
  <div class="quickbuy-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'quickbuy-page',
}
</script>
